export {
    Context as QueriesPanelContext,
    Provider as QueriesPanelContextProvider,
    Consumer as QueriesPanelConsumer
} from './QueriesPanelContext'